import { FC } from 'react';

import { Alert } from '@belong/ui-components';
import { ALERT_LEVELS, ALERT_POSITION } from '@belong/types';

import CONTENT from '../content.json';

export const FeedbackDone: FC = () => (
  <Alert type={ALERT_LEVELS.SUCCESS} position={ALERT_POSITION.INLINE} hasFocus>
    {CONTENT.feedback.comment.success}
  </Alert>
);
